'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.debounceValidator = void 0;
var validators_1 = require("vuelidate/lib/validators");
var helpers_1 = require("../helpers");
/**
 * Creates a debounced promise based validator function
 *
 * @param validator The validator to debounce
 * @param delayMs The delay to use.
 * @param rules List of rules to pass before validating
 */
function debounceValidator(validator, delayMs, rules) {
    if (rules === void 0) { rules = []; }
    var resolver = function () { return null; };
    var rejecter = function () { return null; };
    // prettier-ignore
    var debouncedValidator = helpers_1.debounce(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = validator.apply(this, args);
        if (result instanceof Promise) {
            result.then(resolver, rejecter);
            return;
        }
        resolver(result);
    }, delayMs);
    return function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        if (rules.length && !validators_1.and.apply(void 0, rules).apply(void 0, values)) {
            return false;
        }
        return new Promise(function (resolve, reject) {
            resolver = resolve;
            rejecter = reject;
            debouncedValidator.apply(void 0, values);
        });
    };
}
exports.debounceValidator = debounceValidator;
